let animationFrameId = null; // global inside module so unmount can access
let resize_handler = null;

export default {
  name: "BolideLoader",
  props: {
    is_visible: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    this.startBolideLoader();
    this.sync_body_scroll_lock();
  },

  beforeUnmount() {
    // 🔥 Prevent memory leak when the loader is removed
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }

    if (resize_handler) {
      window.removeEventListener("resize", resize_handler);
      resize_handler = null;
    }

    document.body.classList.remove("bolide-loader-lock");
  },

  watch: {
    is_visible() {
      this.sync_body_scroll_lock();
    },
  },

  methods: {
    sync_body_scroll_lock() {
      document.body.classList.toggle("bolide-loader-lock", this.is_visible);
    },

    startBolideLoader() {
      const CONFIG = {
        colors: { 
          bg: '#0d0d12', 
          c1: '#e40072',
          c2: '#f05f39',
          c3: '#fdb50a'
        },
        waves: 3,
        particlesPerWave: 20,
        waveGap: 2800,
        loopAnimation: true
      };

      const canvas = this.$refs.bolide_loader_canvas;

      if (!canvas) return;

      const ctx = canvas.getContext("2d");

      let width, height;
      let particles = [];

      // =============================
      // RESIZE HANDLER
      // =============================
      resize_handler = () => {
        width = window.innerWidth;
        height = window.innerHeight;

        canvas.width = width;
        canvas.height = height;
      };

      window.addEventListener("resize", resize_handler);
      resize_handler();

      // =============================
      // BOLIDE LINE CLASS
      // =============================
      class BolideLine {
        constructor(waveIndex) {
          this.waveIndex = waveIndex;
          this.init();
        }

        init() {
          this.baseY = height / 2 + (Math.random() * 160 - 80);
          const waveOffset = this.waveIndex * CONFIG.waveGap;

          this.x = -400 - Math.random() * 1500 - waveOffset;
          this.length = Math.random() * 500 + 400;
          this.width = Math.random() * 3 + 1;

          this.speed = Math.random() * 15 + 10;

          this.amp = Math.random() * 30 + 10;
          this.freq = Math.random() * 0.005 + 0.002;
          this.phase = Math.random() * Math.PI * 2;

          this.active = true;
        }

        update() {
          this.x += this.speed;

          if (this.x - this.length > width) {
            this.active = false;
          }
        }

        draw(ctx) {
          if (!this.active) return;

          ctx.save();
          ctx.lineCap = "round";
          ctx.lineJoin = "round";
          ctx.lineWidth = this.width;

          const headY = this.baseY + Math.sin(this.x * this.freq + this.phase) * this.amp;
          const tailX = this.x - this.length;
          const tailY = this.baseY + Math.sin(tailX * this.freq + this.phase) * this.amp;

          const gradient = ctx.createLinearGradient(tailX, tailY, this.x, headY);
          gradient.addColorStop(0, "rgba(228, 0, 114, 0)");
          gradient.addColorStop(0.2, CONFIG.colors.c1);
          gradient.addColorStop(0.6, CONFIG.colors.c2);
          gradient.addColorStop(1, CONFIG.colors.c3);

          ctx.strokeStyle = gradient;
          ctx.shadowBlur = 10;
          ctx.shadowColor = CONFIG.colors.c1;

          ctx.beginPath();
          const segments = 20;

          for (let i = 0; i <= segments; i++) {
            const px = this.x - (this.length * (i / segments));
            const py = this.baseY + Math.sin(px * this.freq + this.phase) * this.amp;

            if (i === 0) ctx.moveTo(px, py);
            else ctx.lineTo(px, py);
          }

          ctx.stroke();
          ctx.restore();
        }
      }

      // =============================
      // START SEQUENCE
      // =============================
      const startSequence = () => {
        particles = [];

        for (let w = 0; w < CONFIG.waves; w++) {
          for (let i = 0; i < CONFIG.particlesPerWave; i++) {
            particles.push(new BolideLine(w));
          }
        }

        animate();
      };

      // =============================
      // ANIMATION LOOP
      // =============================
      const animate = () => {
        ctx.clearRect(0, 0, width, height);

        let activeParticles = 0;

        particles.forEach(p => {
          p.update();
          p.draw(ctx);

          if (p.active) activeParticles++;
        });

        if (activeParticles > 0) {
          // 🔥 ESLINT-FIX → animationFrameId is now used
          animationFrameId = requestAnimationFrame(animate);
        } else if (CONFIG.loopAnimation) {
          setTimeout(startSequence, 2000);
        }
      };

      startSequence();
    }
  }
};
